import { ApiAddress } from '@/services/apis'
import { ID } from '@/services/common.model'
import { TOKEN_NAME } from '@/utils/constants'
import { InboxOutlined } from '@ant-design/icons'
import { message, Modal, UploadProps } from 'antd'
import Dragger from 'antd/lib/upload/Dragger'
import { memo, useState } from 'react'

interface UploadFileProps {
  trigger: JSX.Element
  dirId?: ID
  onSuccess: Function
}

export default memo<UploadFileProps>(function UploadFile(props) {
  const { trigger, dirId, onSuccess } = props
  const [isModalVisible, setIsModalVisible] = useState(false)

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleOk = () => {
    setIsModalVisible(false)
    onSuccess()
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  const uploadProps: UploadProps = {
    name: 'file',
    multiple: true,
    action: ApiAddress.DIRECTORY_FILES.replace(':id', String(dirId)),
    data: { fileType: 'PROJECT_FILES' },
    withCredentials: true,
    headers: { 'ORBIT-TOKEN': localStorage.getItem(TOKEN_NAME) || '' },
    onChange(info) {
      const { status, response } = info.file
      if (response && !response.errorCode) {
        message.success(`${info.file.name} file uploaded successfully.`)
      }
      if (status === 'error' || !!response?.errorCode) {
        message.error(`${info.file.name} file upload failed.`)
      }
    }
  }

  return (
    <>
      <span onClick={showModal}>{trigger}</span>
      <Modal
        title='Upload'
        visible={isModalVisible}
        maskClosable={false}
        destroyOnClose={true}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Dragger {...uploadProps}>
          <p className='ant-upload-drag-icon'>
            <InboxOutlined />
          </p>
          <p className='ant-upload-text'>Click or drag file to this area to upload</p>
        </Dragger>
      </Modal>
    </>
  )
})
